export default "__VITE_ASSET__OcubE_M5__"